import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ActionButton } from "components/primitives/ActionBarButton";
import { useCountdown } from "hooks/timers/useCountdown";

type BackToHomeButtonProps = { finishOrder: () => void };

/**
 * Timer button, that redirects user from Order step 5 to Order step 1 after
 * purchase is completed
 * @param finishOrder
 * @constructor
 */
export const BackToHomeButton = ({ finishOrder }: BackToHomeButtonProps) => {
	const { countdown } = useCountdown(10, finishOrder);
	const { t } = useTranslation();
	if (countdown > 0) {
		return (
			<ActionButton onClick={() => finishOrder()} stretch={true}>
				<Typography
					variant={"h5"}
					color={"white"}
					fontWeight={900}
					textTransform={"uppercase"}
				>
					{t("order.step5.backToHome", { countdown })}
				</Typography>
			</ActionButton>
		);
	}
	return null;
};
